import ApiService from "./ApiService";

/**
 * Service to handle request about users
 */
const GroupService = {
  async getGroups(): Promise<GroupType[]> {
    return ApiService.get<GroupType[]>("/groups");
  },
  async createGroup(colorPalette: GroupColorPalette) {
    return ApiService.post("/groups", { name: "Nouveau groupe", colorPalette });
  },
  async updateGroup(group: GroupType) {
    return ApiService.put("/groups", { id: group.id, colorPalette: group.colorPalette, name: group.name });
  },
  async addUserToGroup(userId: number, groupId: number) {
    return ApiService.post("/groups/add_user", { userId, groupId });
  },
  async removeUserFromGroup(userId: number, groupId: number) {
    return ApiService.post("/groups/remove_user", { userId, groupId });
  },
  async deleteGroup(groupId: number) {
    return ApiService.delete(`/groups/${groupId}`);
  },
  async updateGroupLeader(groupId: number, username: string) {
    return ApiService.put("/groups/leader", { groupId, username });
  },
};

export default GroupService;
